import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'

type ViewStandardColumnResourceV3 = OpalApiComponent<
  'V3',
  'view_standard_column'
>

export const viewStandardColumnResourceFactory: Factory<ViewStandardColumnResourceV3> =
  Factory.define<ViewStandardColumnResourceV3>(({ sequence }) => {
    return {
      id: uuidV4(),
      type: 'view_standard_column',
      attributes: {
        system_name: `standard_column_${sequence}`,
        display_name: `Standard Column ${sequence}`,
        default_position: sequence,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      },
      relationships: {},
    } satisfies ViewStandardColumnResourceV3
  })
